import { render, staticRenderFns } from "./FawryPay.vue?vue&type=template&id=71b7cc70&scoped=true&"
import script from "./FawryPay.vue?vue&type=script&lang=js&"
export * from "./FawryPay.vue?vue&type=script&lang=js&"
import style0 from "./FawryPay.vue?vue&type=style&index=0&id=71b7cc70&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71b7cc70",
  null
  
)

export default component.exports